// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 13) return "static/js/5a222cbfde1879ca1c8e.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ad5b64fb23f6293f5485","135":"d1f260657857f41fbc68","136":"bdb54c758d8ba42b6e5f"}[chunkId] + ".chunk.js";
};